import axios from 'axios'
import Utils from '@/common/utils'

const url = `${process.env.VUE_APP_BASE_API}/api`
const headers = { Authorization: Utils.setLocalToken() }

export default class ClientUserService {
  static async create (user) {
    const { data } = await axios.post(`${url}/clientUser/`, user, { headers })
    return data
  }

  static async update (user) {
    const { data } = await axios.put(`${url}/clientUser/${user.userId}`, user, { headers })
    return data
  }

  // @clientId: Number
  static async getAdminsCount (params) {
    const { data } = await axios.get(`${url}/clients/getAdminsCount`, { headers, params })
    return data
  }

  static async list (params) {
    const { data } = await axios.get(`${url}/clientUser`, { headers, params })
    return data?.data
  }
}
